import React from 'react'
import Head from 'next/head'
import LoginForm from 'src/component/Pages/Login'
import useLogin from 'src/hooks/use-login'

export default function LoginPage() {
  const { handleSubmit, error, loading, loginForms, updateForm, success } =
    useLogin(true)

  return (
    <>
      <Head>
        <title>Login - MyCitygate Portal</title>
      </Head>
      <LoginForm
        onSubmit={handleSubmit}
        success={success}
        error={error}
        loading={loading}
        formData={loginForms}
        onChange={updateForm}
      />
    </>
  )
}
